(function () {
  function esc(value) {
    if (window.CSS && CSS.escape) return CSS.escape(value);
    return String(value).replace(/["\\]/g, '\\$&');
  }

  function detach(root) {
    if (root.parentElement === document.body) return;
    var sid = root.dataset.section;
    document.querySelectorAll('body > .eqb-sticky-atc').forEach(function (old) {
      if (old !== root && old.dataset.section === sid) old.remove();
    });
    document.body.appendChild(root);
  }

  function initSticky(root) {
    if (root.dataset.saInit) return;
    root.dataset.saInit = '1';
    detach(root);

    var sectionId = root.dataset.section;
    var variants = {};
    var dataEl = root.querySelector('[data-eqb-sticky-variants]');
    if (dataEl) {
      try {
        variants = JSON.parse(dataEl.textContent);
      } catch (e) {
        variants = {};
      }
    }

    var idInput = root.querySelector('input[name="id"]');
    var select = root.querySelector('.eqb-sticky-atc__select');
    var saleEl = root.querySelector('.eqb-sticky-atc__price .sale');
    var compareEl = root.querySelector('.eqb-sticky-atc__price .compare');
    var discountEl = root.querySelector('.eqb-sticky-atc__price .discount');
    var mainVs = document.getElementById('variant-selects-' + sectionId);

    function variantIdByName(name) {
      for (var k in variants) {
        if (Object.prototype.hasOwnProperty.call(variants, k) && variants[k].name === name) return k;
      }
      return null;
    }

    function renderPrice(vid) {
      var v = variants[vid];
      if (!v) return;
      if (saleEl) saleEl.innerHTML = v.price;
      if (compareEl) {
        if (v.hasCompare) {
          compareEl.innerHTML = v.compare;
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (discountEl) {
        if (v.hasCompare) {
          discountEl.innerHTML = '-' + v.discount + '%';
          discountEl.hidden = false;
        } else {
          discountEl.hidden = true;
        }
      }
    }

    function setVariant(vid, syncMain) {
      if (!vid || !variants[vid]) return;
      if (idInput) {
        idInput.value = vid;
        idInput.disabled = variants[vid].available === false;
      }
      if (select && select.value !== String(vid)) select.value = String(vid);
      renderPrice(vid);

      if (syncMain && mainVs) {
        var name = variants[vid].name;
        var radio = mainVs.querySelector('input[type="radio"][value="' + esc(name) + '"]');
        if (radio) {
          if (!radio.checked) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          }
        } else {
          var opt = mainVs.querySelector('select option[value="' + esc(name) + '"]');
          if (opt) {
            var sel = opt.closest('select');
            if (sel && sel.value !== name) {
              sel.value = name;
              sel.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
        }
      }
    }

    if (select) {
      select.addEventListener('change', function () {
        setVariant(select.value, true);
      });
    }

    if (mainVs) {
      mainVs.addEventListener('change', function () {
        var checked = mainVs.querySelector('input[type="radio"]:checked');
        var val = null;
        if (checked) {
          val = checked.value;
        } else {
          var selEl = mainVs.querySelector('select');
          if (selEl) val = selEl.value;
        }
        if (val == null) return;
        var vid = variantIdByName(val);
        if (vid) setVariant(vid, false);
      });
    }

    var initId = idInput && idInput.value ? idInput.value : select ? select.value : null;
    if (initId) setVariant(initId, false);

    if (root.dataset.trigger === 'always') {
      root.classList.add('is-visible');
      return;
    }

    var inline =
      document.getElementById('ProductSubmitButton-' + sectionId) ||
      document.querySelector('#ProductInfo-' + sectionId + ' .renew-prpage-cart-btn');

    if (!inline || !('IntersectionObserver' in window)) {
      root.classList.add('is-visible');
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          root.classList.toggle('is-visible', !entry.isIntersecting);
        });
      },
      { threshold: 0 }
    );
    io.observe(inline);
  }

  function initAll() {
    document.querySelectorAll('.eqb-sticky-atc').forEach(initSticky);
  }

  if (document.readyState !== 'loading') {
    initAll();
  } else {
    document.addEventListener('DOMContentLoaded', initAll);
  }
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:unload', function (e) {
    var sid = e.detail && e.detail.sectionId;
    if (!sid) return;
    document.querySelectorAll('body > .eqb-sticky-atc').forEach(function (el) {
      if (el.dataset.section === sid) el.remove();
    });
  });
})();
